import { render, staticRenderFns } from "./SectionHeading.vue?vue&type=template&id=14681c62&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"
import style0 from "./SectionHeading.vue?vue&type=style&index=0&id=14681c62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14681c62",
  null
  
)

export default component.exports